import {CheckCircleFillIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {mergeabilityStatus, Status} from '@github-ui/mergebox/helpers/mergeability-status'
import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {useGoToMergeBox} from '../../mergebox/use-go-to-mergebox'
import {useMergeabilityData} from './use-mergeability-data'
import {usePullRequestAnalytics} from '../../../../hooks/use-pull-request-analytics'

export function AbleToMerge() {
  const data = useMergeabilityData()
  const goToMergeBox = useGoToMergeBox()
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()

  if (!data) return null

  const {mergeBoxPullRequest, mergeRequirements, statusChecksData} = data
  const status = mergeabilityStatus({
    pullRequest: mergeBoxPullRequest,
    mergeRequirements,
    statusChecksData,
  })
  const mergeRequirementsSatisfied =
    mergeRequirements?.state === 'MERGEABLE' || mergeRequirements?.state === 'MERGEABLE_IF_STATUSES_PASS'

  if (!mergeRequirementsSatisfied || status !== Status.NonRequiredChecksUnsuccessful) return null

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={CheckCircleFillIcon} />}
      title="Able to merge"
      itemName="able-to-merge"
      description="Some non-required checks are failing"
      actionSlot={
        <Button
          size="small"
          onClick={event => {
            sendPullRequestAnalyticsEvent('overview.for_you_item_action', 'OVERVIEW_FOR_YOU_ITEM', {
              item_name: 'able-to-merge',
              action_name: 'go_to_merge_box',
            })
            goToMergeBox(event.currentTarget)
          }}
        >
          Go to merge box
        </Button>
      }
    />
  )
}
